export default {
  watch: {
    video: {
      handler (value) {
        this.updateVideo(value)
      }
    }
  },
  methods: {
    videoComponents () {
      const video = this.video

      const updateVideo = this.updateVideo
      // const updateVideoSphere = this.updateVideoSphere

      if (!AFRAME.components.video) {
        AFRAME.registerComponent('video', {
          init () {
            // const videoMesh = this.el.getObject3D('mesh')
            console.log('init video')
            updateVideo(video)

            if (video) {
              this.el.addEventListener('click', this.toggle)
            }
          },
          remove () {
            this.el.removeEventListener('click', this.toggle)
            delete AFRAME.components.video
          },
          toggle () {
            const videoElement = document.querySelector('video')
            debugger
            if (videoElement) {
              if (videoElement.paused) {
                videoElement.play()
              } else {
                videoElement.pause()
              }
            }
          }
        })
      }
    },
    updateVideo (video) {
      // const videoElement = document.querySelector('video-asset')
      const videoElement = document.getElementById('video')
      if (video) {
        videoElement.addEventListener('progress', function (evt) {
          console.log('video loading ', evt)
        })

        videoElement.addEventListener('loaded', function (evt) {
          console.log('video loaded ', evt)
        })

        videoElement.addEventListener('error', function (evt) {
          console.log('video error ', evt)
        })

        videoElement.setAttribute('src', video.file)

        console.log('update video')
        document.getElementById('video').setAttribute('visible', true)
        document.querySelector('[cube]').setAttribute('visible', false)
      }

      // const videoTexture = new THREE.VideoTexture(videoElement)
      // videoTexture.minFilter = THREE.LinearFilter
      // videoTexture.magFilter = THREE.LinearFilter
      // videoTexture.format = THREE.RGBFormat

      // const videoMesh = new THREE.MeshBasicMaterial({
      //   map: videoTexture
      // })

      // videoMesh.material = videoMesh
    }
  }
}
